import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  SvgIcon,
} from '@mui/material';
import { makeStyles } from '@mui/styles';
import React from 'react';
import { ReactComponent as ChevronIcon } from '../../images/chevron-right.svg';
import { colors } from '../../utils/theme';

const useStyles = makeStyles(() => ({
  expandIcon: {
    '&$expanded': {
      transform: 'rotate(90deg)',
      marginTop: 5,
    },
  },
  expanded: {},
}));

export const AccordionCard = ({
  summary,
  details,
  panelId,
  onChange,
}: {
  summary: React.ReactNode;
  details: React.ReactNode;
  panelId: string;
  onChange?: () => void;
}): JSX.Element => {
  const classes = useStyles();

  return (
    <div>
      <Accordion
        disableGutters
        onChange={onChange}
        sx={{
          py: 1.5,
          background: colors.greys.BASE_WHITE,
          border: `1px solid ${colors.greys.GREY_300}`,
          '&.MuiPaper-root': {
            boxShadow: '0px 1px 2px 0px #1018280D',
            borderRadius: 1.25,
          },
        }}
      >
        <AccordionSummary
          classes={{
            expandIconWrapper: classes.expandIcon,
            expanded: classes.expanded,
          }}
          expandIcon={
            <SvgIcon
              component={ChevronIcon}
              inheritViewBox
              sx={{
                marginTop: 1.65,
                width: 20,
                height: 20,
                fill: colors.greys.BASE_WHITE,
              }}
            />
          }
          aria-controls={`${panelId}-content`}
          id={`${panelId}-header`}
          sx={{
            '&.MuiAccordionSummary-root': {
              alignItems: 'flex-start',
            },
          }}
        >
          {summary}
        </AccordionSummary>
        <AccordionDetails id={`${panelId}-content`} sx={{ pt: 0 }}>
          {details}
        </AccordionDetails>
      </Accordion>
    </div>
  );
};
